document.addEventListener('turbolinks:load', () => {
  const clearFlashBanner = () => setTimeout(() => {
    $('.flash-banner').fadeOut(1000);
  }, 5000);

  clearFlashBanner();
});
